'use strict';

var React = require('react');

var SvgCodeMinor = function SvgCodeMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.707 9.707a.996.996 0 0 0 .293-.707v-4a1 1 0 0 1 1-1 1 1 0 0 0 0-2c-1.654 0-3 1.346-3 3v3.586l-.707.707a.999.999 0 0 0 0 1.414l.707.707v3.586c0 1.654 1.346 3 3 3a1 1 0 0 0 0-2 1 1 0 0 1-1-1v-4a.997.997 0 0 0-.293-.707l-.293-.293.293-.293Zm13.217-.09a1 1 0 0 0-.217-.324l-.707-.707v-3.586c0-1.654-1.346-3-3-3a1 1 0 1 0 0 2 1 1 0 0 1 1 1v4a.996.996 0 0 0 .293.707l.293.293-.293.293a.996.996 0 0 0-.293.707v4a1 1 0 0 1-1 1 1 1 0 0 0 0 2c1.654 0 3-1.346 3-3v-3.586l.707-.707a1 1 0 0 0 .217-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.626 5.284a1.002 1.002 0 0 0-1.63.346l-1.998 4-1.998 4a.999.999 0 0 0 .56 1.299 1.006 1.006 0 0 0 1.302-.557l3.995-8a1.001 1.001 0 0 0-.231-1.088Z"
  }));
};

exports.SvgCodeMinor = SvgCodeMinor;
